<template>
  <div class="row animated fadeIn step-container">
    <div class="col-md-8 offset-md-2 step-body clinic-leave-wrapper">
      <h4 class="step-header">
        <div class='title'>{{$t('message.leave.title')}}</div>
        <button @click.prevent="newLeave" class="add-leave btn btn-success">+ {{$t('action_message.add')}}</button>

        <div class="btn-group toggle_view_group" role="group" aria-label="">
          <button type="button" v-if="!showCalendar" @click="showCalendarView()" class="btn btn-sq-border"><i class="fa fa-calendar"></i> {{$t('message.leave.calendar')}}</button>
          <button type="button" v-if="showCalendar" @click="showListView()" class="btn btn-sq-border"><i class="fa fa-list"></i> {{$t('message.leave.list')}}</button>
        </div>
      </h4>

      <div class="row">
        <div class="col-12">
          <bs-input v-model='doctorSearchQ' :placeholder="$t('message.leave.search_doctor')"></bs-input>
        </div>
      </div>
      <div class="row" v-show="!showCalendar">
        <div class="col-12">
          <div v-if="!$ismobile()">
            <table class="table table-bordered table-responsive">
              <thead width="100%">
                <tr v-if="$guser.isClinic() || $guser.isClinicMulti()">
                  <th class="text-center" width="25%">{{$t('message.leave.date')}}</th>
                  <th class="text-center" width="25%">{{$t('message.leave.name')}}</th>
                  <th class="text-center" width="30%">{{$t('message.leave.remark')}}</th>
                  <th class="text-center" width="10%"></th>
                </tr>
                <tr v-else>
                  <th class="text-center" width="25%">{{$t('message.leave.date')}}</th>
                  <th class="text-center" width="65%">{{$t('message.leave.remark')}}</th>
                  <th class="text-center" width="10%"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="leave in displayLeaveList.data" :key="leave.id">
                  <td class="text-center">
                    <div v-if="leave.all_day">
                      <span>{{leave.start_time | formatDateFull}}</span>
                      <span>-</span>
                      <span>{{leave.end_time | formatDateFull}}</span>
                    </div>

                    <div v-else>
                      <span>{{leave.start_time | formatDateTimeFull}}</span>
                      <span>-</span>
                      <span>{{leave.end_time | formatDateTimeFull}}</span>
                    </div>
                  </td>
                  <td v-if="$guser.isClinic() || $guser.isClinicMulti() ">
                    <div>
                      <a href="javascript:void(0)" @click.prevent="openDoctor(leave.doctor_id)">{{getDoctorName(leave)}}</a>
                    </div>
                    <small class="text-one-ellipsis">{{getDoctorSpecialty(leave)}}</small>
                  </td>
                  <td class="text-justify">
                    <span>{{viewContent(leave.description, !leave.showMoreContent)}}</span>
                    <a v-if="leave.moreContentEnable" class="view-more-btn" href="javascript:void(0)" @click.prevent="toggleMoreContent(leave)">{{leave.showMoreContent ? $t('action_message.close') : $t('action_message.more')}}</a>
                  </td>
                  <td class="text-center">
                    <a href="javascript:void(0)">
                      <i class="fa fa-pencil-square-o" @click="editLeave(leave)"><small> {{$t('action_message.edit')}}</small></i>
                    </a>
                  </td>
                </tr>
                <tr v-if="loaded && displayLeaveList.data.length === 0">
                  <td colspan='4' style='text-align: center;' class='alert alert-warning'>
                    <span>{{$t('message.leave.no_leave')}}</span>
                  </td>
                </tr>
                <tr v-if="loading">
                  <td colspan='4' style='text-align: center;' class='alert alert-warning'><div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div></td>
                </tr>
              </tbody>
            </table>
            <!-- <div class='pagination'>
              <div><strong>{{$t('message.pagination.show')}}</strong> {{ leaveList.from }} - {{ leaveList.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ leaveList.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
              <a class='btn' @click="leaveList.prev_page_url && loadLeaveList(leaveList.prev_page_url)" :class="{ enable: leaveList.prev_page_url }">{{$t('message.pagination.prev')}}</a>
              <a class='btn' @click="leaveList.next_page_url && loadLeaveList(leaveList.next_page_url)" :class="{ enable: leaveList.next_page_url }">{{$t('message.pagination.next')}}</a>
            </div> -->
          </div>

          <!-- For mobile -->
          <div v-else>
            <div class="leave-list-container">
              <!-- <div v-if="loaded && leaveList.data.length !== 0" class='pagination'>
                <div><strong>{{$t('message.pagination.show')}}</strong> {{ leaveList.from }} - {{ leaveList.to }} <strong>{{$t('message.pagination.from')}}</strong> {{ leaveList.total }} <strong>{{$t('message.pagination.rows')}}</strong></div>
                <a class='btn' @click="leaveList.prev_page_url && loadLeaveList(leaveList.prev_page_url)" :class="{ enable: leaveList.prev_page_url }">{{$t('message.pagination.prev')}}</a>
                <a class='btn' @click="leaveList.next_page_url && loadLeaveList(leaveList.next_page_url)" :class="{ enable: leaveList.next_page_url }">{{$t('message.pagination.next')}}</a>
              </div> -->
              <div class='card leave-list-content' v-for="leave in displayLeaveList.data" :key="leave.id">
                <div class='card-header'>
                  <div class="row">
                    <span v-if="leave.all_day" class='col-12 app-id'>
                      {{$t('message.leave.date')}}: {{leave.start_time | formatDateFull}} - {{leave.end_time | formatDateFull}}
                    </span>
                    <span v-else class='col-12 app-id'>
                      {{$t('message.leave.date')}}: {{leave.start_time | formatDateTimeFull}} - {{leave.end_time | formatDateTimeFull}}
                    </span>
                  </div>
                </div>
                <div class='card-block'>
                  <h5 class='app-doctor'>
                    <a href="javascript:void(0)" @click.prevent="openDoctor(leave.doctor_id)">{{getDoctorName(leave)}}</a>
                  </h5>
                  <span class="app-remark">{{viewContent(leave.description, !leave.showMoreContent)}}</span>
                  <a v-if="leave.moreContentEnable" class="view-more-btn" href="javascript:void(0)" @click.prevent="toggleMoreContent(leave)">{{leave.showMoreContent ? $t('action_message.close') : $t('action_message.more')}}</a>
                  <br>
                  <div>
                    <a href="javascript:void(0)" @click="editLeave(leave)">
                      <span> {{$t('action_message.edit')}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <h6 v-if="loaded && displayLeaveList.data.length === 0" class="text-center alert alert-warning">
              {{$t('message.leave.no_leave')}}
            </h6>
            <div v-if="loading" class="text-center">
              <div v-show='loading' class='btn btn-sm'><sync-loader size='10px'></sync-loader></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-show="showCalendar">
        <div class="col-12">
          <div id="leaveCalendar"></div>
          <br/>
          <br/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import 'fullcalendar'
import 'fullcalendar-scheduler'
import 'fullcalendar/dist/fullcalendar.min.css'
import 'fullcalendar-scheduler/dist/scheduler.min.css'
import jq from 'jquery'
// import moment from 'moment'
import SyncLoader from 'vue-spinner/src/SyncLoader'
import { input as BsInput } from 'vue-strap'

export default {
  components: {
    SyncLoader,
    BsInput
  },
  data () {
    return {
      limitContentLength: 80,
      loading: false,
      loaded: false,
      leaveList: {data: []},
      doctorSearchQ: null,
      showCalendar: false,
      fc: null,
      createdCalendar: false,
      calendarResources: [],
      calendarEvents: []
    }
  },
  computed: {
    displayLeaveList () {
      return Object.assign({}, this.leaveList, {
        data: this.leaveList.data.filter(leave => {
          return !this.doctorSearchQ || `${leave.doctor.firstname} ${leave.doctor.lastname}`.search(this.doctorSearchQ) > -1
        })
      })
    }
  },
  methods: {
    openDoctor (id) {
      if (id) this.$router.push({path: `/doctor/step1/${id}`, query: {action: 'edit', ref_clinic_id: this.$route.query.ref_clinic_id}})
    },
    getDoctorName (data) {
      if (data && data.doctor) {
        return `${data.doctor.prefix}${data.doctor.firstname} ${data.doctor.lastname}`
      }
      return ''
    },
    getDoctorSpecialty (data) {
      return ''
    },
    toggleMoreContent (data) {
      data.showMoreContent = !data.showMoreContent
    },
    viewContent (content, isTruncate) {
      if (isTruncate) {
        return this.$options.filters.truncate(content, this.limitContentLength)
      }
      return content
    },
    async loadLeaveList (url) {
      if (this.$guser.isClinic() || this.$guser.isDoctor() || this.$guser.isClinicMulti()) {
        this.loading = true
        this.loaded = false
        let params = {ref_clinic_id: this.$route.query.ref_clinic_id}
        if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
          params.clinic_id = this.$guser.user.clinic.id
        } else if (this.$guser.isDoctor()) {
          params.doctor_id = this.$guser.user.doctor.id
        }
        let res = await this.$http.get(url || this.$APP_CONFIG.api.admin.timeoffs(),
          {
            params: params,
            credentials: true
          })

        this.loading = false
        this.loaded = true
        this.leaveList = Object.assign({}, {
          data: res.body.map(d => {
            return Object.assign({}, d, {
              showMoreContent: false,
              moreContentEnable: d && (d.description) && (d.description.length > this.limitContentLength)
            })
          })
        })
        // this.leaveList = Object.assign({}, {
        //   from: res.body.from,
        //   to: res.body.to,
        //   total: res.body.total,
        //   per_page: res.body.per_page,
        //   current_page: res.body.per_page,
        //   next_page_url: res.body.next_page_url,
        //   prev_page_url: res.body.prev_page_url,
        //   data: (res.body.data) ? res.body.data.map(d => {
        //     return Object.assign({}, d, {
        //       showMoreContent: false,
        //       moreContentEnable: d && (d.content) && (d.content.length > this.limitContentLength)
        //     })
        //   }) : {}
        // })
      }
    },
    newLeave () {
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        this.$router.push({
          path: '/clinic/leave/add',
          query: {
            ref_clinic_id: this.$route.query.ref_clinic_id
          }
        })
      } else {
        this.$router.push({path: '/doctor/leave/add'})
      }
    },
    editLeave (leave) {
      if (this.$guser.isClinic() || this.$guser.isClinicMulti()) {
        this.$router.push({path: `/clinic/leave/${leave.doctor_id}/${leave.id}`, query: {ref_clinic_id: this.$route.query.ref_clinic_id}})
      } else {
        this.$router.push({path: `/doctor/leave/${leave.id}`})
      }
    },
    async setupCalendar () {
      var self = this
      this.fc = jq('#leaveCalendar')

      // init fullcalendar with events
      // doc: https://fullcalendar.io/docs/views/Available_Views/
      this.fc.fullCalendar({
        locale: this.$i18n.locale,
        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        defaultView: this.dayView,
        defaultDate: new Date(),
        editable: true,
        slotLabelFormat: 'HH:mm',
        titleFormat: 'ddd MMM D, YYYY',
        allDaySlot: false,
        header: {
          left: 'prev, today',
          center: 'title',
          right: 'next'
        },
        slotEventOverlap: false,
        resourceLabelText: this.$t('message.appointment.doctor_list'),
        resources: this.calendarResources,
        events (start, end, timezone, callback) {
          self.processEventCalendar(start, end, timezone, callback)
        },
        eventDrop (event, delta, revertFunc, jsEvent, ui, view) {
          self.processEventDrop(event, delta, revertFunc, jsEvent, ui, view)
        },
        eventResize (event, jsEvent, ui, view) {
          self.processEventResize(event, jsEvent, ui, view)
        },
        eventClick (event, jsEvent, view) {
          self.processEventClick(event, jsEvent, view)
        },
        dayClick (date, jsEvent, view, resource) {
          self.processDayClick(date, jsEvent, view, resource)
        },
        eventRender (event, element) {
          self.processEventRender(event, element)
        }
      })
    },
    processEventCalendar (start, end, timezone, callback) {
      var events = []
      this.displayLeaveList.data.forEach(leave => {
        events.push({
          id: leave.id,
          resourceId: leave.doctor_id,
          title: `${leave.doctor.firstname} ${leave.doctor.lastname}`,
          start: leave.start_time.split(' ').join('T'),
          end: leave.end_time.split(' ').join('T'),
          color: '#FF0000',
          data: leave
        })

        if (!this.calendarResources.find(cr => cr.id === leave.doctor_id)) {
          var r = {
            id: leave.doctor_id,
            title: `${leave.doctor.firstname} ${leave.doctor.lastname}`,
            data: leave.doctor
          }
          this.calendarResources.push(r)
          this.fc.fullCalendar('addResource', r)
        }
      })
      this.calendarEvents = events
      callback(events)
    },
    processEventDrop (event, delta, revertFunc, jsEvent, ui, view) {},
    processEventResize (event, jsEvent, ui, view) {},
    processEventClick (event, jsEvent, view) {
      if (event.data) this.editLeave(event.data)
    },
    processDayClick (date, jsEvent, view, resource) {

    },
    processEventRender (event, element) {},
    refetchEvents () {
      if (this.fc) {
        this.fc.fullCalendar('refetchEvents')
      }
    },
    showListView () {
      this.$router.push({path: '/clinic/leave'})
    },
    showCalendarView () {
      this.$router.push({
        path: '/clinic/leave',
        query: {
          view_type: 'calendar',
          ref_clinic_id: this.$route.query.ref_clinic_id
        }
      })
    }
  },
  watch: {
    $route (v, old) {
      this.showCalendar = v.query && v.query.view_type === 'calendar'
    },
    showCalendar (v, o) {
      if (v && !this.createdCalendar) {
        this.setupCalendar()
      } else if (v) {
        this.refetchEvents()
      }
    },
    displayLeaveList (v, o) {
      if (this.showCalendar) {
        this.refetchEvents()
      }
    }
  },
  created () {
    this.showCalendar = this.$route.query && this.$route.query.view_type === 'calendar'
    this.loadLeaveList()
  },
  mounted () {
    if (this.showCalendar && !this.createdCalendar) {
      this.setupCalendar()
    }
  }
}
</script>

<style lang='scss'>
@import "../../../assets/base_container";

.view-more-btn {
  float: right;
}

.pagination {
  align-items: center;
}

.clinic-leave-wrapper {
  .step-header {
    display: flex;
    justify-content: center;
    align-items: center;

    .title {
        flex: 1;
    }
  }
}

.toggle_view_group {
  margin-left: 1rem;
}

</style>



// WEBPACK FOOTER //
// LeaveList.vue?05f4827c